import { useOverlayPosition, useOverlayTrigger } from '@react-aria/overlays';
import type { DOMRefValue } from '@react-types/shared';
import React, { useRef } from 'react';
import { unwrapDOMRef } from '../../../../../utils';
import { Popover } from '../../../../date-picker-overlays/popover';
import { DialogTriggerBase } from '../dialog-trigger-base';

export const PopoverTrigger = ({
  state,
  targetRef,
  trigger,
  content,
  hideArrow,
  isKeyboardDismissDisabled,
  ...props
}: any) => {
  let triggerRef = useRef<HTMLElement>(null);

  let overlayRef = useRef<DOMRefValue<HTMLDivElement>>(null);
  let {
    overlayProps: popoverProps,
    placement,
    arrowProps
  } = useOverlayPosition({
    targetRef: targetRef || triggerRef,
    overlayRef: unwrapDOMRef(overlayRef),
    placement: props.placement,
    containerPadding: props.containerPadding,
    offset: props.offset,
    crossOffset: props.crossOffset,
    shouldFlip: props.shouldFlip,
    isOpen: state.isOpen
  });

  let { triggerProps, overlayProps } = useOverlayTrigger({ type: 'dialog' }, state, triggerRef);

  let triggerPropsWithRef = {
    ...triggerProps,
    ref: targetRef ? undefined : triggerRef
  };

  let overlay = (
    <Popover
      isOpen={state.isOpen}
      UNSAFE_style={popoverProps.style}
      ref={overlayRef}
      onClose={state.close}
      placement={placement}
      arrowProps={arrowProps}
      isKeyboardDismissDisabled={isKeyboardDismissDisabled}
      hideArrow={hideArrow}
    >
      {typeof content === 'function' ? content(state.close) : content}
    </Popover>
  );

  return (
    <DialogTriggerBase
      type="popover"
      state={state}
      triggerProps={triggerPropsWithRef}
      dialogProps={overlayProps}
      trigger={trigger}
      overlay={overlay}
    />
  );
};
